import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-code-render',
  templateUrl: './code-render.component.html',
  styleUrls: ['./code-render.component.scss']
})
export class CodeRenderComponent {
  @Input() language: string = "html";
  @Input() code: string = `
    Sin datos
  `;
}
